// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__NsEqh","group":"Form_group__dm_0Z","reversed":"Form_reversed__e1BLb"};